// extracted by mini-css-extract-plugin
export default {"link-list":"DashboardQuickLinks_link-list__kIMSJ"};